module.exports = __webpack_public_path__ + "img/repair-and-maintenance-icon.4b95b171.svg";